// libraries
import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
// hooks & context
// styles
import * as SC from "./Styled";
// types & models
import { IMarkerTapObject } from "~/interfaces";
import { IATCamera } from "@algo/network-manager/models/v4";
// components
import ExtendedObjectDetails from "../../extended-object-details/ExtendedObjectDetails";
import BackButton from "../../back-button/BackButton";
// resources
import { getFirstCameraFromGroup } from "~/store/algo-api/slices/camera-group";
// constants


export type IProps = {
    object?: IMarkerTapObject;
    doneCallback?: any;
    backCallback?: any;
    objectCallback?: any;
};

export const CameraGroupModal: React.FC<IProps> = (props) => {

    const { type, data } = props.object ?? {};

    const firstCamera: IATCamera|null = data ? getFirstCameraFromGroup(data) : null;

    if (!data) return null;

    return (
        <SC.CameraGroupWrapper>

            <SC.buttonWrapper>
                <BackButton callback={() => props.backCallback()} />

                <SC.Header>{`${firstCamera?.location.displayRouteDesignator}` + 
                    `${firstCamera?.location.displayCrossStreet 
                        ? " @ " + firstCamera.location.displayCrossStreet 
                        : ""
                    }`}</SC.Header>

                <SC.xIconWrapper onClick={props.doneCallback}>
                    <FontAwesomeIcon
                        className="fa-fw"
                        size={"lg"}
                        icon={faXmark}
                        color={"rgba(235, 235, 245, 0.6)"}
                    />
                </SC.xIconWrapper>
            </SC.buttonWrapper>

            <ExtendedObjectDetails object={data} type={type} isVideoboard={true} objectCallback={props.objectCallback} />

        </SC.CameraGroupWrapper>
    );
};

export default CameraGroupModal;